module.exports = __webpack_public_path__ + "static/media/project-images.f040ae73.png";